<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.date" :error="form.errors.date" type="date" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Date')" readonly />

          <select-input v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('User')" :disabled="true">
            <option :value="null">{{ __('Select Customer') }}</option>
            <option v-for="s in organization" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          <select-input v-model="form.customer_id" :error="form.errors.customer_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Customer')" :disabled="true">
            <option :value="null">{{ __('Select User') }}</option>
            <option v-for="s in customer" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          <select-input v-model="form.type_outgoing" :required="true" :error="form.errors.type_outgoing" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Type Outgoing')" :disabled="true">
            <option :value="null">{{ __('Select Type') }}</option>
            <option v-for="s in type_outgoings" :key="s.value" :value="s.value">{{ s.name }}</option>
          </select-input>

          <textarea-input v-model="form.description" :error="form.errors.description" :rows="8" class="pb-6 w-full lg:w-1/1" placeholder="description here.." :label="__('Note')" readonly></textarea-input>

          <!-- BTTPU Image Section -->
          <div v-if="form.new_bttpu_image || form.bttpu_image" class="w-full flex items-center space-x-4 mt-4">
            <img :src="getBttpuImageUrl()" alt="BTTPU Image" class="w-32 h-32 object-cover border rounded-md shadow-sm cursor-pointer" @click="previewBastImage(getBttpuImageUrl())" />
            <button type="button" @click="removeBttpuImage()" class="btn btn-danger ml-2">{{ __('Remove') }}</button>
          </div>
          <div v-else class="w-full mt-4">
            <file-input v-model="form.new_bttpu_image" :error="form.errors.new_bttpu_image" class="pb-8 pr-6 w-full lg:w-1/3" type="file" accept="image/*" :label="__('Image BTTPU')" />
          </div>

          <!-- Details Section -->
          <div class="pr-6 pb-8 w-full mt-12">
            <label class="form-label mb-6">{{ __('Details') }}:</label>

            <!-- Table for Details -->
            <div class="bg-white rounded-md shadow overflow-x-auto">
              <table class="min-w-full bg-white border-0">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-4 py-2 text-center">{{ __('No') }}</th>
                    <th class="px-4 py-2 text-center">{{ __('Category') }}</th>
                    <th class="px-4 py-2 text-center">{{ __('Brand') }}</th>
                    <th class="px-4 py-2 text-center">{{ __('Type') }}</th>
                    <th class="px-4 py-2 text-center">{{ __('Serial Number') }}</th>
                    <th class="px-4 py-2 text-center">{{ __('User') }}</th>
                    <th class="px-4 py-2 text-center">{{ __('Qty') }}</th>
                    <th class="px-4 py-2 text-cengef">{{ __('Status') }}</th>
                    <th class="px-4 py-2 text-center">{{ __('Asset Status') }}</th>
                    <th class="px-4 py-2 text-center">{{ __('Image BAST') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(detail, index) in form.details" :key="index">
                    <td class="px-4 py-2 text-center">{{ index + 1 }}</td>
                    <td class="px-4 py-2 text-center">{{ detail.category }}</td>
                    <td class="px-4 py-2 text-center">{{ detail.brand }}</td>
                    <td class="px-4 py-2 text-center">{{ detail.type }}</td>
                    <td class="px-4 py-2 text-center">{{ detail.serial_number }}</td>
                    <td class="px-4 py-2 text-center">{{ detail.user }}</td>
                    <td class="px-4 py-2 text-center">{{ detail.qty }}</td>
                    <td class="px-4 py-2 text-center">
                      <span v-if="detail.resign == true" class="px-2 py-0.5 rounded-full text-white bg-green-500 font-bold text-xs">In Stock</span>
                      <span v-else class="px-2 py-0.5 rounded-full text-white bg-red-500 font-bold text-xs">Out of Stock</span>
                    </td>
                    <td class="px-4 py-2 text-center">
                      <!-- Available -->
                      <span v-if="detail.status === 'available'" class="px-2 py-0.5 rounded-full bg-green-500 text-white font-bold text-xs"> Available </span>

                      <!-- Outgoing -->
                      <span v-else-if="detail.status === 'outgoing'" class="px-2 py-0.5 rounded-full bg-blue-500 text-white font-bold text-xs"> Outgoing </span>

                      <!-- Inden Part -->
                      <span v-else-if="detail.status === 'inden_part'" class="px-2 py-0.5 rounded-full bg-yellow-500 text-white font-bold text-xs"> Inden Part </span>

                      <!-- Sold -->
                      <span v-else-if="detail.status === 'sold'" class="px-2 py-0.5 rounded-full bg-red-500 text-white font-bold text-xs"> Sold </span>

                      <!-- Damaged -->
                      <span v-else-if="detail.status === 'damaged'" class="px-2 py-0.5 rounded-full bg-red-500 text-white font-bold text-xs"> Damaged </span>

                      <!-- Default (Out of Stock) -->
                      <span v-else class="px-2 py-0.5 rounded-full bg-gray-500 text-white font-bold text-xs"> Out of Stock </span>
                    </td>
                    <td class="px-4 py-2 text-center">
                      <div v-if="detail.new_image_bast || detail.image_bast" class="flex flex-col items-center mt-4 mx-8">
                        <img :src="getBastImageUrl(detail)" alt="BAST Image" class="w-32 h-32 object-cover border rounded-md shadow-sm cursor-pointer" @click="previewBastImage(getBastImageUrl(detail))" />
                        <button v-if="detail.status === 'outgoing'" type="button" @click="removeBastImage(index)" class="btn btn-danger mt-2">{{ __('Remove') }}</button>
                      </div>

                      <div v-else class="w-full mt-4">
                        <file-input v-if="detail.status === 'outgoing'" v-model="form.details[index].new_image_bast" :error="form.errors[`details.${index}.new_image_bast`]" class="pb-8 pr-6 w-full lg:w-1/3" type="file" accept="image/*" :label="__('Upload Image BAST')" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ __('Upload') }}
          </loading-button>
        </div>
      </form>

      <!-- Preview Modal -->
      <Modal v-if="showPreviewModal" @close="closePreviewModal" :title="'Image BAST'">
        <template #content>
          <img :src="bastImageUrl" alt="Preview Image" class="w-full h-full mb-4" />
          <div class="flex justify-between">
            <a :href="bastImageUrl" download class="btn btn-primary">{{ __('Download') }}</a>
            <button type="button" @click="closePreviewModal()" class="btn btn-secondary ml-2">{{ __('Close') }}</button>
          </div>
        </template>
      </Modal>
    </div>
  </div>
</template>


  <script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal'
import { formatDate } from '@/utils/dateFormatter.js'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  metaInfo() {
    return { title: this.title }
  },
  components: {
    LoadingButton,
    TextInput,
    SelectInput,
    Head,
    FileInput,
    Modal,
    TextareaInput,
  },
  layout: Layout,
  props: {
    title: String,
    data_exit_goods: Object,
    asset: Array,
    customer: Array,
    organization: Array,
    brand: Array,
    category: Array,
    type: Array,
    serial_number: Array,
    type_outgoings: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        date: formatDate(this.data_exit_goods.date, 'YYYY-MM-DD'),
        customer_id: this.data_exit_goods.customer_id,
        organization_id: this.data_exit_goods.organization_id,
        bttpu_image: this.data_exit_goods.bttpu_image || null,
        type_outgoing: this.data_exit_goods.type_outgoing,
        new_bttpu_image: null,
        details: this.data_exit_goods.details.map((detail) => ({
          category: detail.category,
          brand: detail.brand,
          type: detail.type,
          serial_number: detail.serial_number,
          qty: detail.qty,
          user: detail.user,
          image_bast: detail.image_bast || null,
          new_image_bast: null,
          status: detail.status,
          resign: detail.resign,
        })),
      }),
      showPreviewModal: false,
      bastImageUrl: null,
    }
  },
  methods: {
    getBastImageUrl(detail) {
      if (detail.new_image_bast instanceof File) {
        return URL.createObjectURL(detail.new_image_bast) // Local preview for new image
      } else if (detail.image_bast) {
        return `/${detail.image_bast}` // Path from server
      }
      return ''
    },
    getBttpuImageUrl() {
      if (this.form.new_bttpu_image instanceof File) {
        return URL.createObjectURL(this.form.new_bttpu_image) // Local preview for new image
      } else if (this.form.bttpu_image) {
        return `/${this.form.bttpu_image}` // Path from server
      }
      return ''
    },
    previewBastImage(image) {
      this.bastImageUrl = image
      this.showPreviewModal = true
    },
    closePreviewModal() {
      this.showPreviewModal = false
      this.bastImageUrl = null
    },
    removeBastImage(index) {
      this.form.details[index].new_image_bast = null
      this.form.details[index].image_bast = null
    },
    removeBttpuImage() {
      this.form.new_bttpu_image = null
      this.form.bttpu_image = null
    },
    update() {
      this.form.post(this.route('exit_goods.upload_bast', this.data_exit_goods.id))
    },
  },
}
</script>
